import React from "react";
import StudentListView from "../views/StudentListView";
import TeacherListView from "../views/TeacherListView";
import MobileListView from "../views/mobile/MobileListView";

export function renderStudentsMenuContent({
    isMobile,
    students,
    teachers,
    visitLogs,
    attendanceLogs,
    studentListType,
    setStudentListType,
    studentSearchTerm,
    setStudentSearchTerm,
    addItem,
    updateItem,
    deleteItem,
    bulkAddItem,
    bulkDeleteItem,
    handleNavigateToAttendance,
    handleNavigateToLog,
    tourAction,
    studentToEdit,
    setStudentToEdit,
    selectedDepartment,
    myDepartments,
    userProfile,
    currentTheme,
    incrementStat,
    handleOpenCheerModal,
    targetStudentId,
    setTargetStudentId,
    detailReturnMenu,
    setDetailReturnMenu,
    setActiveMenu
}) {
    if (isMobile) {
        return (
            <MobileListView
                students={students}
                teachers={teachers}
                visitLogs={visitLogs}
                attendanceLogs={attendanceLogs}
                listType={studentListType}
                setListType={setStudentListType}
                searchTerm={studentSearchTerm}
                setSearchTerm={setStudentSearchTerm}
                onAdd={(d) => addItem("students", { ...d, attendance: 0, lastVisit: "-" })}
                onUpdate={(d) => updateItem("students", d.id, d)}
                onDelete={(id) => deleteItem("students", id)}
                onAddTeacher={(d) => addItem("teachers", d)}
                onUpdateTeacher={(d) => updateItem("teachers", d.id, d)}
                onDeleteTeacher={(id) => deleteItem("teachers", id)}
                onNavigateToAttendance={handleNavigateToAttendance}
                onNavigateToVisit={handleNavigateToLog}
                onUpdateLog={(d) => updateItem("visitLogs", d.id, d)}
                onDeleteLog={(id) => deleteItem("visitLogs", id)}
                onAddLog={(d) => addItem("visitLogs", d)}
                theme={currentTheme}
                selectedDepartment={selectedDepartment}
                myDepartments={myDepartments}
                userProfile={userProfile}
                onOpenCheerModal={handleOpenCheerModal}
                targetStudentId={targetStudentId}
                onClearTargetStudentId={() => setTargetStudentId(null)}
                detailReturnMenu={detailReturnMenu}
                onClearDetailReturnMenu={() => setDetailReturnMenu(null)}
                onNavigateMenu={setActiveMenu}
            />
        );
    }

    return (
        <StudentListView
            students={students}
            teachers={teachers}
            onAdd={(d) => addItem("students", { ...d, attendance: 0, lastVisit: "-" })}
            onBulkAdd={(items) => bulkAddItem("students", items)}
            onUpdate={(d) => updateItem("students", d.id, d)}
            onDelete={(id) => deleteItem("students", id)}
            onBulkDelete={(ids, names) => bulkDeleteItem("students", ids, names)}
            onAddTeacher={(d) => addItem("teachers", d)}
            onUpdateTeacher={(d) => updateItem("teachers", d.id, d)}
            onDeleteTeacher={(id) => deleteItem("teachers", id)}
            studentToEdit={studentToEdit}
            onClearStudentToEdit={() => setStudentToEdit(null)}
            attendanceLogs={attendanceLogs}
            visitLogs={visitLogs}
            onNavigateToAttendance={handleNavigateToAttendance}
            onNavigateToVisit={handleNavigateToLog}
            onUpdateLog={(d) => updateItem("visitLogs", d.id, d)}
            onDeleteLog={(id) => deleteItem("visitLogs", id)}
            demoAction={tourAction === "spotlight" ? "spotlight" : (tourAction === "demo_add_student" ? "add" : null)}
            listType={studentListType}
            setListType={setStudentListType}
            searchTerm={studentSearchTerm}
            setSearchTerm={setStudentSearchTerm}
            selectedDepartment={selectedDepartment}
            myDepartments={myDepartments}
            userProfile={userProfile}
            theme={currentTheme}
            onIncrementStat={incrementStat}
            targetStudentId={targetStudentId}
            onClearTargetStudentId={() => setTargetStudentId(null)}
            detailReturnMenu={detailReturnMenu}
            onClearDetailReturnMenu={() => setDetailReturnMenu(null)}
            onNavigateMenu={setActiveMenu}
        />
    );
}

export function renderTeachersMenuContent({
    teachers,
    meetingMinutes,
    addItem,
    updateItem,
    deleteItem,
    bulkAddItem,
    bulkDeleteItem,
    tourAction,
    attendanceLogs,
    visitLogs,
    handleNavigateToAttendance,
    handleNavigateToLog,
    selectedDepartment,
    myDepartments,
    userProfile,
    currentTheme,
    handleOpenCheerModal,
    targetTeacherId,
    setTargetTeacherId,
    detailReturnMenu,
    setDetailReturnMenu,
    setActiveMenu
}) {
    return (
        <TeacherListView
            teachers={teachers}
            onAdd={(d) => addItem("teachers", d)}
            onBulkAdd={(items) => bulkAddItem("teachers", items)}
            onUpdate={(d) => updateItem("teachers", d.id, d)}
            onDelete={(id) => deleteItem("teachers", id)}
            onBulkDelete={(ids, names) => bulkDeleteItem("teachers", ids, names)}
            minutes={meetingMinutes}
            onAddMinute={(d) => addItem("meetingMinutes", d)}
            onUpdateMinute={(d) => updateItem("meetingMinutes", d.id, d)}
            onDeleteMinute={(id) => deleteItem("meetingMinutes", id)}
            demoAction={tourAction === "demo_add_teacher" ? "add" : null}
            attendanceLogs={attendanceLogs}
            visitLogs={visitLogs}
            onNavigateToAttendance={handleNavigateToAttendance}
            onNavigateToVisit={handleNavigateToLog}
            onUpdateLog={(d) => updateItem("visitLogs", d.id, d)}
            onDeleteLog={(id) => deleteItem("visitLogs", id)}
            selectedDepartment={selectedDepartment}
            myDepartments={myDepartments}
            userProfile={userProfile}
            theme={currentTheme}
            onOpenCheerModal={handleOpenCheerModal}
            targetTeacherId={targetTeacherId}
            onClearTargetTeacherId={() => setTargetTeacherId(null)}
            detailReturnMenu={detailReturnMenu}
            onClearDetailReturnMenu={() => setDetailReturnMenu(null)}
            onNavigateMenu={setActiveMenu}
        />
    );
}
